
import { defineComponent } from "vue";
import router from "@/router";
import {
  GetMetricData,
  GetMetric,
  SummaryTitleByQuarter,
  GetHighlight,
  ChangeOverTime,
  SourceURL,
  NumberWithCommas,
} from "@/utils";
import Spinner from "@/components/Spinner.vue";
import MetricGrid from "@/components/MetricGrid.vue";
import LineChart from "@/components/Chart/LineChart.vue";
import ChartOptions from "@/types/chartOptions";
import FilterTabs from "@/components/Chart/FilterTabs.vue";
import MetricTitle from "@/components/MetricTitle.vue";
import SectionTitle from "@/components/SectionTitle.vue";
import MetricStat from "@/components/MetricStat.vue";
import MetricSource from "@/components/MetricSource.vue";
import MetricHighlight from "@/components/MetricHighlight.vue";
import Metric from "@/types/metric";

export default defineComponent({
  data() {
    return {
      data: [],
      selectedData: [],
      metric: {} as Metric,
      summaryDate: new Date(),
      latestNumbersGain: "",
      latestNumbersLoss: "",
      yearChangeGain: "",
      yearPercentChangeGain: "",
      yearChangeLoss: "",
      yearPercentChangeLoss: "",
      rank: "",
      highlight: "",
      filterOptions: [1, 5, 10, 0],

      //Chart setup
      options: new ChartOptions(),
      dataLabels: ["Job Gains", "Job Losses"],
      dataProps: ["gross_job_gains", "gross_job_losses"],
    };
  },
  components: {
    Spinner,
    LineChart,
    MetricGrid,
    MetricTitle,
    SectionTitle,
    FilterTabs,
    MetricStat,
    MetricSource,
    MetricHighlight,
  },
  methods: {
    handleFilter(option: any) {
      this.limitData(option);
    },
    limitData(years: number) {
      /* This is going to be custom for each metric, you need to cin some cases 
        convert the lable to a date. Then limit the date to the intended range */

      if (years == 0) {
        this.selectedData = this.data;
      } else {
        let count = -1 * (4 * years);
        this.selectedData = this.data.slice(count);
      }
    },
    summaryTitle() {
      return SummaryTitleByQuarter(this.summaryDate);
    },
    sourceUrl() {
      return SourceURL(this.metric);
    },
  },
  async beforeMount() {
    //@ts-ignore
    const topic = router.currentRoute.value.name; // Get which metric by the route
    this.data = await GetMetricData(topic); // Get raw data from Socrata
    this.metric = GetMetric(topic); // Get metric configuration
    this.selectedData = this.data; // initialize this to "lifetime" and update this variable when a range is selected

    //Add custom chart options
    this.options.scales.yAxis.ticks.callback = (label: any) => {
      return NumberWithCommas(label);
    };

    // Get summary data and hightlights
    const lastItem: any = this.data[this.data.length - 1];
    this.summaryDate = lastItem.date;
    this.latestNumbersGain = NumberWithCommas(lastItem[this.dataProps[0]]);
    this.latestNumbersLoss = NumberWithCommas(lastItem[this.dataProps[1]]);
    this.yearChangeGain = NumberWithCommas(
      ChangeOverTime(this.data, 4, this.dataProps[0], false)
    );
    this.yearPercentChangeGain = ChangeOverTime(
      this.data,
      4,
      this.dataProps[0],
      true
    );
    this.yearChangeLoss = NumberWithCommas(
      ChangeOverTime(this.data, 4, this.dataProps[1], false)
    );
    this.yearPercentChangeLoss = ChangeOverTime(
      this.data,
      4,
      this.dataProps[1],
      true
    );
    this.highlight = GetHighlight(this.data);
  },
});
